import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';
import AccaBarView from './view/index.js';
import {
    selectBetBuilderEnabled,
    selectAccumulatorEnabled,
} from 'modules/acca-bar/store/selectors.js';

const {
    utils: BetslipUtils,
    selectors: { selectBetslip },
} = MojitoServices.Betslip;

const IntentTypes = MojitoPresentation.Base.Intent.Types;
const intentActions = MojitoCore.Intents.actions;

const AccaBarController = ({ mojitoTools }) => {
    const displayTime = 1000 * mojitoTools.config.displayTime;
    const [isVisible, setVisible] = useState(false);
    const betslip = useSelector(selectBetslip);
    const accumulatorEnabled = useSelector(selectAccumulatorEnabled);
    const betBuilderEnabled = useSelector(selectBetBuilderEnabled);
    const dispatch = useDispatch();

    const bet = BetslipUtils.getTopBetslipBet(betslip, {
        single: false,
        accumulator: accumulatorEnabled,
        betBuilder: betBuilderEnabled,
        betBuilderAcca: true,
    });

    useEffect(() => {
        setVisible(!!bet);
        if (bet) {
            const timeout = setTimeout(() => setVisible(false), displayTime);
            return () => clearTimeout(timeout);
        }
    }, [bet, displayTime]);

    return (
        <AccaBarView
            bet={bet}
            isVisible={isVisible}
            onBarClick={() =>
                dispatch(intentActions.publishIntent(IntentTypes.SHOW_SLIDING_BETSLIP))
            }
            hideAccaBar={() => setVisible(false)}
        />
    );
};

export default AccaBarController;
